import { useOutletContext } from "react-router-dom";
import { useEffect } from 'react';
import { APIDisplayNames, APINames, PAGE_TITLE_BASE, PageNames } from '../../Assets/variables';
import { apiInfos } from "../../Assets/API/apiInfos";
import APIPage from "../../Components/APIPage";
import { Helmet } from "react-helmet-async";

const StreamingMarketDataV3 = () => {
    const {setActivePageItem} = useOutletContext();
    const apiInfo = apiInfos.filter(apiInfo => apiInfo.apiName === APINames.streamingMarketDataV3)[0];

    useEffect(() => {
        setActivePageItem(PageNames.Catalog);
    }, []);

    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${APIDisplayNames.StreamingMarketDataV3}`}</title>
                <meta name="description" content={`${apiInfo.description}`} />
                <link rel="canonical" href={`/${PageNames.Catalog}/${APINames.streamingMarketDataV3}`} />
            </Helmet>
            <APIPage apiInfo={apiInfo} />
        </>
    );
};

export default StreamingMarketDataV3;
